import React from 'react';
//import {CSVDownload} from 'react-csv';

//
// var childView = [];
// var listView = [];
// var childCollectorsView = [];
class ChildDetail extends React.Component{
  _childView = [];
  _listView = [];
constructor(props){
  super(props);
  this.state = {
    name:'',
    surname:'',
    data:[],
    ddata:false,
    csvDetails:[],
  }
}


  async componentDidMount(){
    fetch('https://schoolportal.appsdesign.co.za/get_child_details/' + await localStorage.getItem('schoolToken'))
    .then((response) => response.json())
    .then((responseJson) => {
  console.log(responseJson[0][0])

      this.setState({
        data: responseJson,

  }, function(){
console.log(this.state.data)
      });
console.log(this.state.data)
    })
    .catch((error) =>{
      console.error(error);
    });

    }

    onDownLoad = ()=>{

      this.setState({

        ddata:true
      });

    }

onNameChange = (event) =>{

  this.setState({name:event.target.value});
}


onSurnameChange = (event) =>{

  this.setState({surname:event.target.value});
}

getDetail = () =>{

const details = this.state.data.map(detail => {

  return detail.Schoolclass

});

console.log(details)

let allDetails = [];

for(var i = 0; i < details.length ; i++){
  for(var k = 0; k < details[i].length; k++){

      allDetails.unshift(details[i][k])


  }



}

console.log(allDetails);


const csvDetails1 = allDetails.filter(d => {
if(this.state.name === d.childname){
  //console.log(d)
  return d
}
else {
  return null
}

});

const childinfo = [csvDetails1[0]]

 this._childView =  childinfo.map((cv, i) => {
  return (
    <div>
    <table style={{ margin:10}}>
    <tr><th>Child ID</th><th>Child Surname</th><th>Child Name</th><th>Child Gender</th><th>Category</th><th>Class</th><th>Allergies</th></tr>

<tr><td>{cv.schoolID}</td><td>{cv.childsurname}</td><td>{cv.childname}</td><td>{cv.childgender}</td><td>{cv.category}</td><td>{cv.childclass}</td><td>{cv.allergies}</td></tr>
  </table>

  <table style={{ margin:10}}>
   <tbody>
  <tr>
  <th>Collector 1 </th><td>{cv.collectors[0].rel}</td>
  <th>Collector 2 </th><td>{cv.collectors[1] !== undefined ? cv.collectors[1].rel :null}</td>
  <th>Collector 3 </th><td>{cv.collectors[2] !== undefined ? cv.collectors[2].rel :null}</td>
  <th>Collector 4 </th><td>{cv.collectors[3] !== undefined ? cv.collectors[3].rel :null}</td>
  </tr>

  <tr>
  <th>Collector 1 ID</th><td>{cv.collectors[0].code}</td>
  <th>Collector 2 ID</th><td>{cv.collectors[1] !== undefined ? cv.collectors[1].code :null}</td>
  <th>Collector 3 </th><td>{cv.collectors[2] !== undefined ? cv.collectors[2].code :null}</td>
  <th>Collector 4 </th><td>{cv.collectors[3] !== undefined ? cv.collectors[3].code :null}</td>
  </tr>



  <tr>
  <th>Collector 1 Phone </th><td>{cv.collectors[0].phone}</td><
  th>Collector 2 Phone </th><td>{cv.collectors[1] !== undefined ? cv.collectors[1].phone :null}</td>
  <th>Collector 3 </th><td>{cv.collectors[2] !== undefined ? cv.collectors[2].phone :null}</td>
  <th>Collector 4 </th><td>{cv.collectors[3] !== undefined ? cv.collectors[3].code :null}</td>
  </tr>
   </tbody>
  </table>
</div>
)
});


this._listView = csvDetails1.map((item,i) =>{

return(
<tr key={i}>

<td>{item.collectedday}</td>
<td>{item.childname}</td>
<td>{item.childsurname}</td>
<td>{item.collectorname}</td>
<td>{item.collectorno}</td>
<td>{item.collectedat}</td>
<td>{item.absent}</td>
</tr>

)

})





const csvDetails = csvDetails1.map(d => {

  return ({
    "Date":d.collectedday,
    "Child Name":d.childname,
    "Child Surname":d.childsurname,
    "Collector Name":d.collectorname,
    "Collector No":d.collectorno,
    "Time Collected":d.collectedat,
    "Absent":d.absent

  })


});




console.log(csvDetails)

 this.setState({
  csvDetails:csvDetails,
  ddata:true
});
// //alert(JSON.stringify(csvDetails));

 }



render(){

//const csvData = this.state.csvDetails;


return(
    <div className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100,backgroundColor:'white'}}>
<h1>Child Details</h1>
<div>
<label htmlFor="name" style={{marginRight:20}}>
Child Name</label>
<input
type="text"
placeholder="Child Name"
id="name"
className="pa2 ma2"
onKeyUp={this.onNameChange}
/>
<br/>


<label htmlFor="surname">
Child Surname</label>
<input
type="text"
placeholder="Child Surname"
id="surname"
className="pa2 ma2"
onKeyUp={this.onSurnameChange}
/>
<br/>
  <button  className="br3 pa3 bg-blue br-blue" onClick={this.getDetail}>Get Detail</button>
</div>
{this._childView}

  <table style={{ margin:10}}>
   <tbody>
  <tr>
  <td><button  style={{margin:3, height:40}} className="br2 bg-blue br-blue" onClick={this.onDownLoad}>Download Report</button></td>
  </tr>
  <tr>
<th>Date</th><th>Child Name</th><th>Child Surame</th><th>Collector Name</th><th>Collector ID</th><th>Time Collected</th><th>Absent</th>
  </tr>

  {this._listView}
   </tbody>
  </table>




</div>
)

}

}

export default ChildDetail;



// WEBPACK FOOTER //
// ./src/components/ChildDetail/ChildDetail.js